'use client'

import { useSearchParams } from 'next/navigation'
import { interstitialTiming, type InterstitialTiming } from '../motion'

// `?loaderMs=` sets the interstitial sequence length, for tuning its pace on any
// environment. The PDP's links carry the query string, so setting it on a tag URL
// reaches both discovery screens. Anything that isn't a positive number is ignored.
export function parseLoaderMs(value: string | null): number | undefined {
  const ms = Number(value)

  if (!value || !Number.isFinite(ms) || ms <= 0) {
    return undefined
  }

  return ms
}

export function useInterstitialTiming(): InterstitialTiming {
  const searchParams = useSearchParams()

  return interstitialTiming(
    parseLoaderMs(searchParams?.get('loaderMs') ?? null),
  )
}
